import { render, staticRenderFns } from "./groupCommodityAudit.vue?vue&type=template&id=227d2073&"
import script from "./groupCommodityAudit.vue?vue&type=script&lang=js&"
export * from "./groupCommodityAudit.vue?vue&type=script&lang=js&"
import style0 from "./groupCommodityAudit.vue?vue&type=style&index=0&id=227d2073&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports